export * from "./Bom2aPosSelectTable";
